import { ReactComponent as OnboardingTitleIcon2 } from 'assets/icons/onboarding-icon-2.svg';
import handBagsImage from 'assets/images/hand-bags.png';
import Button from 'components/atoms/Button';
import type { BottomSheetProps } from 'components/molecules/BottomSheet';
import BottomSheet from 'components/molecules/BottomSheet';
import { BUTTON_NAMES } from 'constant/button-names';
import useImagePreloader from 'hooks/useImagePreloader';
import React, { useCallback } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { StyledTitle } from '../shared';

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const StyledDescription = styled.p`
  color: ${({ theme }) => theme.components.gettingBagBottomSheet.description.color};
  font-weight: 300;
  font-size: 12px;
  line-height: 18px;
  margin-bottom: 7px;
`;

const StyledUL = styled.ul`
  padding-left: 18px;
`;

const StyledBoldText = styled.span`
  font-weight: 500;
`;

const description = ['whatToExpectBottomSheet.description.0', 'whatToExpectBottomSheet.description.1', 'whatToExpectBottomSheet.description.2'];

export default function GettingBagBottomsheet({ ...props }: BottomSheetProps) {
  const { t } = useTranslation();

  const handleClose = useCallback(() => {
    props.onClose?.();
  }, [props]);

  useImagePreloader([handBagsImage]);

  return (
    <BottomSheet {...props}>
      <div className="mb-10">
        <StyledImage src={handBagsImage} alt="handbag-image" />
        <StyledTitle>
          <OnboardingTitleIcon2 /> {t('whatToExpectBottomSheet.title')}
        </StyledTitle>
        <StyledUL>
          {description.map((d) => (
            <li key={d}>
              <StyledDescription>
                <Trans
                  components={{
                    bold: <StyledBoldText />,
                  }}
                >
                  {d}
                </Trans>
              </StyledDescription>
            </li>
          ))}
        </StyledUL>
      </div>
      <Button onClick={handleClose} buttonName={BUTTON_NAMES.GOT_IT}>
        {t('common.gotIt')}
      </Button>
    </BottomSheet>
  );
}
